import { FC, ReactNode } from "react";

interface ResultItemProps {
  title: string;
  date: string;
  icon: ReactNode;
}

export const ResultItem: FC<ResultItemProps> = ({ title, date, icon }) => {
  return (
    <div className="flex items-center gap-4">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gray-50">
        {icon}
      </div>
      <div className="min-w-0 flex-1">
        <h4 className="text-base font-light text-gray-900">{title}</h4>
        <p className="text-xs font-light text-gray-400">{date}</p>
      </div>
    </div>
  );
};
